// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"222":"9c3bd105","418":"4238b8db","7937":"e9f65214","8046":"9c3bd105","9322":"e9f65214"}[chunkId] + ".chunk.css";
};